/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FieldRequest } from './FieldRequest';
import {
    FieldRequestFromJSON,
    FieldRequestFromJSONTyped,
    FieldRequestToJSON,
    FieldRequestToJSONTyped,
} from './FieldRequest';

/**
 * 
 * @export
 * @interface CreateMeetingRequest
 */
export interface CreateMeetingRequest {
    /**
     * URL-safe name for the meeting
     * @type {string}
     * @memberof CreateMeetingRequest
     */
    niceName: string;
    /**
     * The ID of the Google Account to use
     * @type {string}
     * @memberof CreateMeetingRequest
     */
    accountId: string;
    /**
     * The ID of the Google Calendar to use
     * @type {string}
     * @memberof CreateMeetingRequest
     */
    calendarId: string;
    /**
     * The scheduling strategy type
     * @type {string}
     * @memberof CreateMeetingRequest
     */
    strategyType: CreateMeetingRequestStrategyTypeEnum;
    /**
     * Optional custom fields for the booking form
     * @type {Array<FieldRequest>}
     * @memberof CreateMeetingRequest
     */
    customFields?: Array<FieldRequest>;
}


/**
 * @export
 */
export const CreateMeetingRequestStrategyTypeEnum = {
    CalendarBased: 'CALENDAR_BASED',
    ConfigurationBased: 'CONFIGURATION_BASED'
} as const;
export type CreateMeetingRequestStrategyTypeEnum = typeof CreateMeetingRequestStrategyTypeEnum[keyof typeof CreateMeetingRequestStrategyTypeEnum];


/**
 * Check if a given object implements the CreateMeetingRequest interface.
 */
export function instanceOfCreateMeetingRequest(value: object): value is CreateMeetingRequest {
    if (!('niceName' in value) || value['niceName'] === undefined) return false;
    if (!('accountId' in value) || value['accountId'] === undefined) return false;
    if (!('calendarId' in value) || value['calendarId'] === undefined) return false;
    if (!('strategyType' in value) || value['strategyType'] === undefined) return false;
    return true;
}

export function CreateMeetingRequestFromJSON(json: any): CreateMeetingRequest {
    return CreateMeetingRequestFromJSONTyped(json, false);
}

export function CreateMeetingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateMeetingRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'niceName': json['niceName'],
        'accountId': json['accountId'],
        'calendarId': json['calendarId'],
        'strategyType': json['strategyType'],
        'customFields': json['customFields'] == null ? undefined : ((json['customFields'] as Array<any>).map(FieldRequestFromJSON)),
    };
}

export function CreateMeetingRequestToJSON(json: any): CreateMeetingRequest {
    return CreateMeetingRequestToJSONTyped(json, false);
}

export function CreateMeetingRequestToJSONTyped(value?: CreateMeetingRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'niceName': value['niceName'],
        'accountId': value['accountId'],
        'calendarId': value['calendarId'],
        'strategyType': value['strategyType'],
        'customFields': value['customFields'] == null ? undefined : ((value['customFields'] as Array<any>).map(FieldRequestToJSON)),
    };
}

